<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <h2 class="headline">
          <span class="font-weight-bold d-flex align-center">
            <!-- <v-icon class="mr-3 black--text" @click="goBack()">mdi-arrow-left</v-icon> -->
            {{ $t('verify_otp') }}
          </span>
        </h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <v-img src="@/assets/images/svg/phone_verification.svg" />
        <div class="mt-8 text-center">
          <div class="title font-weight-bold">
            {{ $t('verify_phone_title') }}
          </div>
          <div class="mt-4" v-html="$t('verify_call_instruction', { phone: data_verification.new_phone })" />
        </div>
        <div class="mt-4">
          <div :class="[`d-flex justify-center align-center`, { 'phone-error': hasError }]">
            <div class="sec-phone">
              <div class="">
                +62 999 - 9999 -
              </div>
            </div>
            <div class="ml-3">
              <CodeInput :loading="false" :fields="4" :auto-focus="true" :field-width="50" :field-height="50" class="input inputVerificationCode" @change="onChangeOtp" @complete="onCompleteOtp" />
              <div v-if="hasError" class="phone-has-error">
                {{ $t('invalid_number') }}
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <div class="__menu-bottom menu-full menu-full-flat">
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
          <div :class="[`mb-3`, { 'd-flex justify-space-between': formattedTimeLeft === 'EXPIRED' }]">
            <div v-if="formattedTimeLeft === 'EXPIRED'" class="font-weight-bold primary--text cursor-pointer" @click="recallOpt(2)">
              {{ $t('recall') }}
            </div>
            <div v-if="formattedTimeLeft !== 'EXPIRED'" class="text-center" v-html="$t('recall_available_in', { time: formattedTimeLeft })" />
            <div v-if="formattedTimeLeft === 'EXPIRED'" class="font-weight-bold primary--text cursor-pointer" @click="recallOpt(1)">
              {{ $t('use_sms_instead') }}
            </div>
          </div>
          <v-btn type="submit" :disabled="disabled_verify" color="primary" block x-large class="text-none" @click="verifyNow()">
            {{ $t('verify') }}
          </v-btn>
        </v-col>
      </div>
    </v-row>
    <v-snackbar v-model="dataSuccess.show" multi-line top color="success" :timeout="3000">
      {{ dataSuccess.message }}
      <v-btn class="transparent" text fab x-small dark @click="closeDataSuccess()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import {
  changePhone as changePhoneCustomer,
  updatePhone as updatePhoneCustomer
} from '@/api/customer'
export default {
  data() {
    return {
      dataSuccess: {
        show: false,
        message: ''
      },
      form: {
        old_phone: '',
        new_phone: '',
        otp_code: ''
      },
      disabled_verify: true,
      data_verification: {},
      hasError: false,
      timerInterval: null,
      distance: 0
    }
  },
  computed: {
    formattedTimeLeft() {
      let minutes = Math.floor((this.distance % (1000 * 60 * 60)) / (1000 * 60))
      let seconds = Math.floor((this.distance % (1000 * 60)) / 1000)
      let result
      if (this.distance < 0) {
        result = 'EXPIRED'
      } else {
        minutes = minutes < 10 ? '0' + minutes : minutes
        seconds = seconds < 10 ? '0' + seconds : seconds
        result = minutes + ':' + seconds
      }
      return result
    }
  },
  watch: {
    formattedTimeLeft: function(newItem, oldItem) {
      if (newItem === 'EXPIRED' || newItem === null) {
        this.disabled_verify = true
      }
    }
  },
  created() {
    this.data_verification = this.$store.state.data_verification
    if (this.data_verification.data) {
      this.getExpiryTime(this.data_verification.data.detail.expiry_date_ext)
    }
  },
  methods: {
    onChangeOtp(v) {
      this.hasError = false
    },
    onCompleteOtp(v) {
      this.hasError = false
      this.form.otp_code = v
      this.disabled_verify = false
    },
    closeDataSuccess() {
      this.dataSuccess.show = false
    },
    getExpiryTime(time) {
      var countDownDate = new Date(time).getTime()
      const _this = this
      this.timerInterval = setInterval(function() {
        var now = new Date().getTime()
        _this.distance = countDownDate - now
        if (_this.distance < 0) {
          clearInterval(_this.timerInterval)
        }
      }, 1000)
    },
    async verifyNow() {
      try {
        this.form.old_phone = this.data_verification.phone
        this.form.new_phone = this.data_verification.new_phone
        await updatePhoneCustomer(this.form)
        this.$store.state.loading_axios = false
        this.dataSuccess.show = true
        this.dataSuccess.message = 'Sukses'
        this.$store.dispatch('remove_data_verification')
        this.$store.dispatch('remove_type_Verification')
        const astra_outlet = this.$store.state.store_astra
        const tmii_outlet = this.$store.state.store_tmii
        const url_id = this.$store.state.url_domain

        if (tmii_outlet.indexOf(url_id) !== -1) {
          window.location.href = 'https://order.kulinertmii.id'
        } else if (astra_outlet.indexOf(url_id) !== -1) {
          window.location.href = 'https://zestloungemenaraastra.myolsera.com'
        } else {
          this.$router.push({ name: 'home' }).catch(() => {})
        }
      } catch (e) {
        this.hasError = true
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    async recallOpt(otp_type = 2) {
      try {
        let obj = {}
        if (otp_type !== 3) {
          obj = {
            otp_type: otp_type,
            new_phone: this.data_verification.data.new_phone,
            old_phone: this.data_verification.data.phone,
            password: this.data_verification.data.password
          }
        } else {
          obj = {
            otp_type: otp_type,
            new_phone: this.data_verification.data.new_phone,
            old_phone: this.data_verification.data.phone,
            password: this.data_verification.data.password
          }
        }
        const { data } = await changePhoneCustomer(obj)
        this.$store.state.loading_axios = false
        if (otp_type === 1) {
          this.$router.push({ name: 'chenge_phone_sms_verification', query: { redirect: this.$route.query.redirect }}).catch(() => {})
        }
        this.data_verification.data.detail = data.data.detail
        this.$store.dispatch('data_verification', this.data_verification)
        this.getExpiryTime(data.data.detail.expiry_date_ext)
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    }
  }
}
</script>
